import { push } from 'connected-react-router';
import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function getTicketTransactionById(id) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_TRANSACTION_CB_JR_UPG_PAGE_REQUEST,
			payload: {
				loading: true
			}
		});

		const response = await API.ticket.status(id);
		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.GET_TRANSACTION_CB_JR_UPG_PAGE_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
		}

		const { ticket } = response.data;

		dispatch({
			type: ActionTypes.GET_TRANSACTION_CB_JR_UPG_PAGE_SUCCESS,
			payload: {
				loading: false
			}
		});

		// DISPATCH AN ACTION TO LOAD TICKET TO TICKETS PAGE
		dispatch({
			type: ActionTypes.GET_TICKETS_PAGE_CALLBACK_FROM_JRUPG,
			payload: {
				ticket
			}
		});

		dispatch(push('/tickets'));
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_CB_JR_UPG_PAGE_META
		});
	};
}

export function resetPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_CB_JR_UPG_PAGE
		});
	};
}
